import { useMutation } from '@tanstack/react-query';
import { setAxiosAuth } from 'utils';
import { postResource } from 'core/api/booking/booking.api';

export const usePostResource = ({ accessToken = '' }) => {
  setAxiosAuth(accessToken);

  return useMutation({
    mutationFn: postResource,
    retry: 0,
  });
}
